/**
 * Obustave na ugovor o djelu po FBiH propisima:
 *
 *   dohodak           = bruto - priznati troškovi
 *   doprinosi PIO/ZO  = stopa x dohodak
 *   poreska osnovica  = dohodak - doprinosi
 *   porez na dohodak  = stopa x poreska osnovica
 *
 * Doprinosi su odbitna stavka, pa porez nikad ne ide na sam dohodak. Stope
 * dolaze iz `platform_settings` i snimaju se na red isplate, pa kasnija
 * promjena ne mijenja historiju.
 */
export interface WithholdingRates {
  recognizedCostsPercent: number;
  incomeTaxPercent: number;
  pensionPercent: number;
  healthPercent: number;
}

export interface WithholdingBreakdown {
  gross: number;
  recognizedCosts: number;
  /** Dohodak: bruto minus priznati troškovi, osnovica za doprinose. */
  income: number;
  pension: number;
  health: number;
  /** Oporezivi dohodak: dohodak minus doprinosi, osnovica za porez. */
  taxBase: number;
  incomeTax: number;
  totalWithheld: number;
  net: number;
}

export function computeWorkContractWithholding(
  gross: number,
  rates: WithholdingRates
): WithholdingBreakdown {
  const g = round2(Math.max(0, gross));
  const recognizedCosts = round2(g * (rates.recognizedCostsPercent / 100));
  const income = round2(g - recognizedCosts);
  const pension = round2(income * (rates.pensionPercent / 100));
  const health = round2(income * (rates.healthPercent / 100));
  const taxBase = round2(Math.max(0, income - pension - health));
  const incomeTax = round2(taxBase * (rates.incomeTaxPercent / 100));
  const totalWithheld = round2(incomeTax + pension + health);

  return {
    gross: g,
    recognizedCosts,
    income,
    pension,
    health,
    taxBase,
    incomeTax,
    totalWithheld,
    net: round2(g - totalWithheld),
  };
}

function round2(value: number): number {
  return Math.round(value * 100) / 100;
}
